import React, { useEffect, useState } from "react";
import { ReactComponent as CloseIcon } from "../assets/CloseIcon.svg";

export default function RulesModel(props) {
  const { setOpen, open, rule } = props;

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (open && !event.target.closest(".rules-model")) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("click", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [open, setOpen]);

  return (
    <>
      {open && (
        <div className="rules-model">
          <div className="rulesModelBox">
            <div className="model-head">
              <h6>طريقة اللعب</h6>
              <button className="close-icon" onClick={() => setOpen(false)}>
                <CloseIcon />
              </button>
            </div>
            <div className="model-body">
              <p>التعليمات الأساسية:</p>
              <ol>
                <li>
                  اختر شريحة الرهان واضغط على منطقة الرهان لوضع رهانك.
                </li>
                <li>
                  بعد انتهاء العد التنازلي، تبدأ الطاولة بالدوران وتظهر كرة صغيرة.عندما تستقر الكرة الصغيرة في منطقة على الطاولة للحصول على نتيجة معينة، يمكنك الحصول على مكافأة عملة ذهبية تساوي (مبلغ الرهان × المضاعف) في منطقة الرهان المطابقة للنتيجة.
                </li>
              </ol>

              <p>شرح المضاعفات:</p>
              <ul>
                <li>
                  <span>0</span> <span>x36</span>
                </li>
                <li>
                  <span>1-12</span> <span>x3</span>
                </li>
                <li>
                  <span>13-24</span> <span>x3</span>
                </li>
                <li>
                  <span>25-36</span>
                  <span>x3</span>
                </li>
                <li>
                  <span>أحمر</span> <span>x2</span>
                </li>
                <li>
                  <span>أسود</span> <span>x2</span>
                </li>
                <li>
                  <span>فردي</span> <span>x2</span>
                </li>
                <li>
                  <span>زوجي</span> <span>x2</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
